// extracted by mini-css-extract-plugin
export default {"step":"Step_step__kFCDT","step__number":"Step_step__number__UjgmK","step__number_border":"Step_step__number_border__wDOtm","step__text":"Step_step__text__spYfU"};